<template>
  <div class="page">
    <div class="doc-home">
      <div class="page__hd">
        <div class="page__hd__main">
          <div class="logo__wrp">
            <img src="@/assets/images/logo.png" />
            <span class="logo__title">云系统帮助中心</span>
          </div>
        </div>
        <div class="page__hd__extra">
          <search-box />
        </div>
      </div>
      <div class="page__bd doc-items">
        <div v-for="item in items" :key="item.id" class="doc-item">
          <router-link :to="'/doc/'+item.code+(item.homepage?'/'+item.homepage:'')">
            <span class="doc-item__icon iconfont icon-book"></span>
            <span class="doc-item__title">{{item.name}}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBox from "@/components/SearchBox.vue";

export default {
  components: {
    SearchBox
  },
  data() {
    return {
      items: []
    };
  },
  created() {
    this.getAll();
  },
  methods: {
    getAll() {
      var me = this;
      me.$ajax({
        url: "/api/help/project/list"
      }).then(function(res) {
        if (res.success) {
          me.items = res.data;
        }
      });
    }
  }
};
</script>

<style scoped>
.page {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--color-bg);
}
.doc-home {
  position: relative;
  width: 80%;
  max-width: 1200px;
  min-width: 960px;
  margin: 0 auto;
  padding-top: 60px;
}
.doc-items {
  margin-right: -100px;
  margin-bottom: -70px;
  padding-top: 70px;
}
.doc-item {
  display: inline-block;
  width: 33.33%;
  padding-right: 100px;
  padding-bottom: 70px;
  box-sizing: border-box;
}
.doc-item a {
  display: block;
  color: #000;
  padding-bottom: 62%;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.03);
  position: relative;
  overflow: hidden;
  transition: transform 0.3s;
}
.doc-item a:hover {
  transform: scale(1.1);
}
.doc-item__icon {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 58px;
  font-size: 4.8rem;
  text-align: center;
  color: var(--color-primary);
}
.doc-item__title {
  position: absolute;
  bottom: 30px;
  width: 100%;
  left: 0;
  text-align: center;
  font-weight: 400;
  font-size: 18px;
}
.page__hd__extra {
  width: 360px;
}
.logo__wrp {
  line-height: 40px;
  font-size: 1.8em;
}
</style>